module.exports = __webpack_public_path__ + "img/teacher8.ae27e00b.webp";